<template>
    <!-- 思维导图 -->
    <div v-if="show" class="read-box">
        <div class="title">
            <img src="https://g.gsxcdn.com/2237465503_21uqvdr2.png" class="left" alt="">
            思维导图
            <img src="https://g.gsxcdn.com/2237465715_nxtc8xeg.png" class="right" alt="">
        </div>
        <!-- 展示单气泡图 "styleId": 1, //1-单气泡图,2-双气泡图,3-人物档案 -->
        <Single v-if="styleId===1" :page-data="pageData"/>
        <!-- 展示双气泡图 -->
        <Double v-if="styleId===2" :page-data="pageData"/>
        <!-- 展示人物介绍 -->
        <Person v-if="styleId===3" :page-data="pageData"/>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import Single from './mind/Single.vue';
import Double from './mind/Double.vue';
import Person from './mind/Person.vue';

@Options({
    components: {
        Single,
        Double,
        Person
    },
    created() {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        styleId() {
            return +this.pageData.opusHistoryInfo?.styleId;
        },
        show() {
            const styleId = +this.pageData.opusHistoryInfo?.styleId;
            return styleId >= 1 && styleId <= 3;
        }
    },
})
export default class Mind extends Vue {
}
</script>

<style lang="scss" scoped>
.read-box {
    width: 8.51rem;
    height: 6.93rem;
    background: url('https://g.gsxcdn.com/2274079824_kb80tuf2.png') 0 0 no-repeat;
    background-size: 100% 100%;
    position: relative;

    .title {
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: .24rem;
        line-height: .56rem;

        .left {
            margin-right: .24rem;
            width: .96rem;
            height: .19rem;
        }

        .right {
            margin-left: .24rem;
            width: .96rem;
            height: .19rem;
        }
    }
}
</style>
